export default {
  "root": "_root_1g5ze_1"
};import "ni:sha-256;XWckmFDjHT2lJeUe-hS3igBxg59f7JfhfE-S47ycNDg";